import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = "/logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="La Finca - Jardín y Villa"
              className="h-24 w-auto bg-white p-2 rounded-lg"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Con la privacidad y belleza que da la naturaleza. Tu escape perfecto en San Cayetano, Nayarit.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/jardinyvillalafinca/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="text-gray-400 hover:text-[#C8962D] transition-colors"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/jardinvillalafinca/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="text-gray-400 hover:text-[#C8962D] transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Enlaces</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/villa" className="text-gray-400 hover:text-white transition-colors">
                  Villa de Descanso
                </Link>
              </li>
              <li>
                <Link to="/jardin" className="text-gray-400 hover:text-white transition-colors">
                  Jardín de Eventos
                </Link>
              </li>
              <li>
                <Link to="/reservar" className="text-gray-400 hover:text-white transition-colors">
                  Reservar
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Servicios</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Hospedaje por Noche</li>
              <li>Renta por Día</li>
              <li>Bodas</li>
              <li>XV Años</li>
              <li>Eventos Corporativos</li>
              <li>Fiestas Privadas</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-lg mb-4 text-[#C8962D]">Contacto</h3>
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#C8962D] flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  La Lava #2, esquina Leopoldo Álvarez Rodríguez, San Cayetano, Nayarit, México 63511
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-[#C8962D] flex-shrink-0" />
                <a href="tel:+523111234567" className="text-sm hover:text-white transition-colors">
                  +52 311 123 4567
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-[#C8962D] flex-shrink-0" />
                <a href="mailto:info@lafinca.mx" className="text-sm hover:text-white transition-colors">
                  info@lafinca.mx
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} La Finca - Jardín y Villa. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacidad" className="text-gray-500 hover:text-white text-sm transition-colors">
              Privacidad
            </Link>
            <Link to="/terminos" className="text-gray-500 hover:text-white text-sm transition-colors">
              Términos
            </Link>
          </div>
        </div>
      </div>

      {/* Novagente Widget */}
      <script src="https://api.novagente.io/widget.js"></script>
    </footer>
  );
}
